import { useEffect } from "react"
import { useRecoilState } from "recoil"
import useAuthContext from "../components/context/AuthContext"
import { getConditionUnits } from "../repositories/conditionUnitRepo"
import conditionUnitListState from "../state/conditionUnitListState"


export const useConditionUnits = () => {
  const [conditionUnits, setConditionUnits] = useRecoilState(conditionUnitListState);
  const { currentShop } = useAuthContext();
  useEffect(() => {
    if(!currentShop?.id) return
    getConditionUnits(currentShop?.id).then((conditionUnits) => {
      setConditionUnits(conditionUnits || [])
    })
  }, [currentShop])

  return [conditionUnits, setConditionUnits]
}
